import { Col } from 'antd';
import { Row } from 'antd';
import { useEffect } from 'react';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { SelectAll } from '../../../_config/constants/select-all.constant';
import { GetAllPharmacies } from '../../../_config/utils/get-all-pharmacies.util';
import CustomSearch from '../../../v2-components/Antd/Search';
import CustomTable from '../../../v2-components/Antd/Table';
import CustomTabs from '../../../v2-components/Antd/Tabs';
import Pharmacies from '../../../v2-components/Pharmacies';
import { typeDelivery } from './constants/type-delivery.constant';
import { Service } from '../service';
import { generateColumns } from './handle/generate-columns.handle';
import { handleSearchParams } from './handle/search-params.handle';
import { mapOptions } from './handle/map-options.handle';
import { tabOptions } from './handle/tab-options.handle';
import { statusPreparation } from './constants/status.constant';
import Loading from '../../../v2-components/Loading';

import './style.css';

export default function AdminListPage() {
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [isTableLoading, setIsTableLoading] = useState(false);
	const history = useHistory();
	const location = useLocation();
	const [options, setOptions] = useState();
	const searchParams = new URLSearchParams(location?.search);
	const pharmacyQueryParam = searchParams.get('pharmacy');
	const [pharmacy, setPharmacy] = useState(pharmacyQueryParam);
	const page = searchParams.get('page');
	const statusQueryParam = searchParams.get('status');
	const [status, setStatus] = useState(statusQueryParam);
	const [deliveryType, setDeliveryType] = useState();
	const [paginationResponse, setPaginationResponse] = useState();
	const [orderSearchText, setOrderSearchText] = useState(null);
	const trxIdQueryParam = searchParams.get('trx_id');
	const [trxId, setTrxId] = useState(trxIdQueryParam);
	const rowKey = '_id';

	const pagination = {
		currentPage: paginationResponse?.currentPage,
		pageSize: paginationResponse?.itemsPerPage,
		totalItems: paginationResponse?.totalItems,
	};

	useEffect(() => {
		setIsTableLoading(true);
		Promise.all([
			new Service().getData({ status, page, pharmacy, delivery_type: deliveryType, trx_id: trxId }),
			new Service().getPharmacies(),
		]).then(([ordersResponse, pharmaciesResponse]) => {
			setPaginationResponse(ordersResponse);
			setData(ordersResponse?.data);
			setIsLoading(false);
			setOptions([SelectAll[Enviroment.LANGUAGE], ...mapOptions(pharmaciesResponse?.data)]);
		}).catch((error) => {
      console.error("Error fetching data", error);
  })
  .finally(() => {
      setIsTableLoading(false);
      setIsLoading(false); 
  });
	}, [status, page, pharmacy, deliveryType, trxId]);

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const onTabChange = () => {
		searchParams.set('page', 1);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
		setDeliveryType(typeDelivery[Enviroment.LANGUAGE].all.toLowerCase());
	};

	const handleStatusQueryChange = (status) => {
		searchParams.set('status', status);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleOperationIdChange = (operation_id) => {
		if (operation_id === '') {
			setTrxId(null);
			searchParams.delete('trx_id');
		} else {
			setTrxId(operation_id);
			searchParams.set('trx_id', operation_id);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleSelectChange = (value) => {
		GetAllPharmacies(value, setPharmacy);
		searchParams.set('pharmacy', value);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleDropdownSelect = (key) => {
		setStatus(key);
		handleStatusQueryChange(key);
	};
	const handleDropdownDelivery = (key) => {
		setDeliveryType(key);
	};

	const handleSearchOrder = (e) => {
		setOrderSearchText(e.target.value);
	};

	const handleTabClick = (key) => {
		const tab = tabOptions(data).find((tab) => tab.key === key);
		if (tab) {
			setStatus(tab.status);
			handleStatusQueryChange(tab.status);
			onTabChange();
		}
		const filteredData = tabOptions(data).map((tab) => ({
			...tab,
			data: tab.data?.filter((item) => {
				return item;
			}),
		}));

		return filteredData;
	};

	const paginationConfig = {
		current: pagination.currentPage,
		pageSize: pagination.pageSize,
		total: pagination.totalItems,
		showSizeChanger: false,
		onChange: (page) => handlePageChange(page),
	};

	const operations = (
		<div className="own-order-search-container">
			<CustomSearch placeholder={'N° de orden'} onChange={handleSearchOrder} onSearch={() => handleOperationIdChange(orderSearchText)} />
		</div>
	);

	const initialActiveTab = tabOptions(data).find((tab) => tab.status === status)?.key;

	const itemsDropdownDelivery = [
		{
			key: 'todas',
			label: typeDelivery[Enviroment.LANGUAGE]['all'],
			value: 'all',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
		{
			key: 'farmacia',
			label: typeDelivery[Enviroment.LANGUAGE]['pharmacy'],
			value: 'pharmacy',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
		{
			key: 'domicilio',
			label: typeDelivery[Enviroment.LANGUAGE]['home'],
			value: 'home',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
		{
			key: 'mixto',
			label: typeDelivery[Enviroment.LANGUAGE]['mixed'],
			value: 'mixed',
			onClick: (e) => handleDropdownDelivery(e.key),
		},
	];

	const itemsDropdownStatus = [
		{
			key: 'all',
			label: statusPreparation[Enviroment.LANGUAGE]['all'],
			value: 'null',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '001',
			label: statusPreparation[Enviroment.LANGUAGE]['001'],
			value: '001',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '002',
			label: statusPreparation[Enviroment.LANGUAGE]['002'],
			value: '002',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '003',
			label: statusPreparation[Enviroment.LANGUAGE]['003'],
			value: '003',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '101',
			label: statusPreparation[Enviroment.LANGUAGE]['101'],
			value: '101',
			onClick: (e) => handleDropdownSelect(e.key),
		},
		{
			key: '201',
			label: statusPreparation[Enviroment.LANGUAGE]['201'],
			value: '201',
			onClick: (e) => handleDropdownSelect(e.key),
		},
	];

	if (isLoading) {
		return <Loading />;
	}
	if (isLoading === false) {
		return (
			<div className="admin-tracking-orders-list-container">
				<Row>
					<Col span={8}>
						<h2>Ordenes de compra</h2>
					</Col>
				</Row>
				<Row justify="left">
					<Pharmacies style={{ width: '50%' }} onChange={handleSelectChange} options={options} />
				</Row>
				<Row>
					<Col span={24}>
						<Col className={'own-order-main-container'}>
							<CustomTabs tabBarExtraContent={operations} onChange={handleTabClick} activeKey={initialActiveTab}>
								{handleTabClick().map((tab) => (
									<CustomTabs key={tab.key} tab={tab.tab}>
										<CustomTable
											dataSource={tab.data}
											columns={generateColumns(itemsDropdownDelivery, itemsDropdownStatus, status)}
											pagination={paginationConfig}
											rowKey={rowKey}
											loading={isTableLoading}
										/>
									</CustomTabs>
								))}
							</CustomTabs>
						</Col>
					</Col>
				</Row>
			</div>
		);
	}
}
